var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_vm._v("\n   Made by PIM\n")])}
var staticRenderFns = []

export { render, staticRenderFns }